import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExtraValidators } from '@teem/utils/ExtraValidators';
import { pad } from '@teem/helpers/functions';
import * as moment from 'moment';
declare var $: any;

@Component({
  selector: 'delivery-duration',
  templateUrl: './delivery-duration.component.html',
  styleUrls: ['./delivery-duration.component.scss']
})
export class DeliveryDurationComponent implements OnInit {
  @Input() formId: string;
  @Input() form;
  @Input() storeInformationForm;
  @Output() onSelect: EventEmitter<FormGroup> = new EventEmitter();
  @Output() onSubmit: EventEmitter<FormGroup> = new EventEmitter();

  isSubmitted: boolean = false;
	moment: any = moment;

  hours: Array<string> = [];
	minutes: Array<string> = [];
  timeModel: any = {
    sunday: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
  }

  constructor(
    private formBuilder: FormBuilder,
    public activeModal1: NgbActiveModal,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    console.log('delivery duration component')
    console.log(this.form)

    for (let i = 0; i <= 23; i++) {
			this.hours.push(pad(i, 2, 0))
		}

		for (let j = 0; j <= 59; j++) {
			this.minutes.push(pad(j, 2, 0))
		}

    // this.form.days.value.forEach((app) => {
    //   if (app.day) {
    //     let day = app.day;
    //     let startTime = moment(app.opening_time, 'HH:mm:ss');
    //     let endTime = moment(app.closing_time, 'HH:mm:ss');

    //     this.form.get('days.'+day+'.available').setValue(true);
    //     this.form.get('days.'+day+'.start_time').setValue(startTime.format('HH:mm:ss'));
    //     this.form.get('days.'+day+'.end_time').setValue(endTime.format('HH:mm:ss'));

    //     this.form.get('days.'+day+'.new_start_time_group').setValue({
    //       hours: startTime.format('HH'),
    //       minutes: startTime.format('mm')
    //     });

    //     this.form.get('days.'+day+'.new_end_time_group').setValue({
    //       hours: endTime.format('HH'),
    //       minutes: endTime.format('mm')
    //     });

    //     this.timeModel[day] = true;
    //   }
    // });
    
  }



  newFormatIn24HoursTime(t: any) {
		return moment(`${t.hours}:${t.minutes}:00}`, 'HH:mm:ss').format('HH:mm:ss')
	}

  get weekDaysInfo() {
    return this.form.get('days') as FormGroup;
  }

  getWeekDaysFormGroup(index) {
    return this.weekDaysInfo.controls[index] as FormGroup;
  }

  getNewStartTimeGroup(day) {
    return this.getWeekDaysFormGroup(day).controls.new_start_time_group;
  }

  getNewEndTimeGroup(day) {
    return this.getWeekDaysFormGroup(day).controls.new_end_time_group;
  }

  onChangeNewStartTime(day) {
    const startTimeValue = this.getNewStartTimeGroup(day).value;
    // if (day == 'monday') {
      // const startTimeValue = this.form['controls'].days['controls'].day['controls'].new_start_time_group.value;
      // const startTimeValue = this.form.controls['days'].controls.[day].new_start_time_group.value;
    // }
    // console.log('startTimeValue');
    // console.log(startTimeValue);
    // console.log(day);
    this.form.get('days.'+day+'.start_time').setValue(this.newFormatIn24HoursTime(startTimeValue));
    let endTime = moment(this.newFormatIn24HoursTime(startTimeValue), 'HH:mm:ss').add(15, 'minutes');
		// this.form.get('days.'+day+'.new_end_time_group').setValue({
		// 	hours: endTime.format('HH'),
		// 	minutes: endTime.format('mm')
		// });

		this.onChangeNewEndTime(day);

		setTimeout(function () {
			$('select[nice-select]').niceSelect('update');
		}, 100);
	}

	onChangeNewEndTime(day) {
    // const endTimeValue = this.form['controls'].days['controls'].monday['controls'].new_end_time_group.value;
    const endTimeValue = this.getNewEndTimeGroup(day).value;
		this.form.get('days.'+day+'.end_time').setValue(this.newFormatIn24HoursTime(endTimeValue));
	}

  openCloseTimeModel(day: string) {
    this.timeModel[day] = !this.timeModel[day];
  }

  openTimeModel(day: string) {
    this.timeModel[day] = !this.timeModel[day];

    this.getWeekDaysFormGroup(day).get('available').setValue(this.timeModel[day]);
    const start_time = this.getWeekDaysFormGroup(day).get('start_time');
    const end_time = this.getWeekDaysFormGroup(day).get('end_time');
    if (this.timeModel[day] == true) {
      start_time.setValidators([Validators.required]);
    } else {
      start_time.setValue(null);
      end_time.setValue(null);
      this.getWeekDaysFormGroup(day).get('new_start_time_group').setValue({
        hours: null,
        minutes: null
      });
      this.getWeekDaysFormGroup(day).get('new_end_time_group').setValue({
        hours: null,
        minutes: null
      });
      
      start_time.clearValidators();
    }
    start_time.updateValueAndValidity();
  }

  submit() {
    this.isSubmitted = true;
    if (this.form.get('days')?.valid) {
      this.isSubmitted = false;
      this.activeModal1.close(this.form)
    } else {
      this.validateDaysInfo();
    }
  }

  validateDaysInfo() {
    const daysGroup = this.form.get('days') as FormGroup;
    daysGroup.markAllAsTouched();
    daysGroup.updateValueAndValidity();
  }

  // activateOption(event, option: string) {
  //   let delivery_cost_international = this.form.get('delivery_cost_international');
  //   if (event.target.checked) {
  //     delivery_cost_international.setValidators([Validators.required, Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
  //   } else {
  //     delivery_cost_international.setValue(null);
  //     delivery_cost_international.setValidators([Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
  //   }
  //   delivery_cost_international.updateValueAndValidity();

  //   this.onSelect.emit(this.form);
  // }

}
